module.exports = __webpack_public_path__ + "static/intercom-integration8-0d4219cf9630a16515c6ef35c2a2efb3.png";